module.exports = __webpack_public_path__ + "static/img/qd-b_bg.3cfb6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/qd-b_bg.png
// module id = lS4I
// module chunks = 1